import { setEnvParams as SEP, useVirtualEnv as UVE, sentryRelease as SR } from './virtual-env.base';

export interface BaseEnv {
  gateway: {
    host: string;
  };
  headers: {
    'g-route': string;
    'g-shadow': string;
  },
  [key: string]: any
}

export function useVirtualEnv<T extends BaseEnv>(): { env: T} {

  return UVE() as {env: T};
}

export function setEnvParams () {
  SEP()
}

export const sentryRelease = SR;
